(function(window, angular) {
  "use strict";

  angular.module('service')
  .factory('origineService', ['baseService', function(baseService) {
    // inherits
    var extended = angular.copy(baseService);
    // url
    extended.base_url = getFullUrl('/api/origine');

    return extended;
  }]);
})(window, window.angular);
